import * as VO from "Data/VoiceOver";
import { StressorType } from "./StressorType";


export const templateStressors: {
    [k in StressorType]: { sprite: string; sprite_graph: string; hoverVO: string; };
} = {
    "dog": {
        sprite: "cyberchase-reststop-dog-stroke",
        sprite_graph: "cyberchase-reststop-dog-dropshadow",
        hoverVO: VO.REST_STOP_PROBLEM_DOG,
    },
    "dozer": {
        sprite: "cyberchase-reststop-dozer-stroke",
        sprite_graph: "cyberchase-reststop-dozer-dropshadow",
        hoverVO: VO.REST_STOP_PROBLEM_CONSTRUCTION,
    },
    "plastic": {
        sprite: "cyberchase-reststop-plastic-stroke",
        sprite_graph: "cyberchase-reststop-plastic-dropshadow",
        hoverVO: VO.REST_STOP_PROBLEM_LITTER,
    },
    "oildrum": {
        sprite: "cyberchase-reststop-oildrum-stroke",
        sprite_graph: "cyberchase-reststop-oildrum-dropshadow",
        hoverVO: VO.REST_STOP_PROBLEM_POLLUTION,
    },
    "truck": {
        sprite: "cyberchase-reststop-truck-stroke",
        sprite_graph: "cyberchase-reststop-truck-dropshadow",
        hoverVO: VO.REST_STOP_PROBLEM_CAR_TRAFFIC,
    },
};
